import 'devextreme/dist/css/dx.light.css';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import mButton from '@/components/widgets/m-button.vue'
import mIcon from '@/components/widgets/m-icon.vue'
import mDivider from '@/components/widgets/m-divider.vue'
import mInput from '@/components/widgets/m-input.vue'
import mModal from '@/components/widgets/m-modal.vue'
import mSelect from '@/components/widgets/m-select.vue'
import mSwitch from '@/components/widgets/m-switch.vue'
import mSimpleCheckbox from '@/components/widgets/m-simple-checkbox.vue'
import mPersonalAgreement from '@/components/widgets/m-personal-agreement.vue'
import mDropdown from '@/components/widgets/m-dropdown.vue'
import mPreview from '@/components/widgets/m-preview.vue'
import mNewMediaViewer from '@/components/widgets/m-new-media-viewer.vue'
import mTextField from '@/components/widgets/m-text-field.vue';
import MAutocomplete from '@/components/widgets/m-autocomplete.vue'
import MTooltip from "@/components/widgets/m-tooltip.vue";
import MConfirmButton from "@/components/widgets/m-confirm-button.vue";
import mSnackbar from "@/components/widgets/Snackbars/m-snackbar.vue";
import mTiptap from '@/components/m-test-templates/m-test-templates-editing/m-tiptap.vue';
import mDragNDropFileUploader from '@/components/widgets/m-drag-n-drop-file-uploader.vue';
import mVideoPlayer from "@/components/widgets/m-video-player.vue";

import '@/assets/scss/index.scss'
import vuetify from './plugins/vuetify'
import Vuelidate from 'vuelidate'

Vue.component('m-button', mButton)
Vue.component('m-icon', mIcon)
Vue.component('m-divider', mDivider)
Vue.component('m-input', mInput)
Vue.component('m-modal', mModal)
Vue.component('m-select', mSelect)
Vue.component('m-switch', mSwitch)
Vue.component('m-simple-checkbox', mSimpleCheckbox)
Vue.component('m-personal-agreement', mPersonalAgreement)
Vue.component('m-dropdown', mDropdown)
Vue.component('m-preview', mPreview)
Vue.component('m-new-media-viewer', mNewMediaViewer)
Vue.component('m-text-field', mTextField)
Vue.component('m-autocomplete', MAutocomplete)
Vue.component('m-tooltip', MTooltip)
Vue.component('m-confirm-button', MConfirmButton)
Vue.component('m-snackbar', mSnackbar)
Vue.component('m-tiptap', mTiptap)
Vue.component('m-drag-n-drop-file-uploader', mDragNDropFileUploader)
Vue.component('m-video-player', mVideoPlayer)

import YandexAdsPlugin from './plugins/yandex-ads'

Vue.use(YandexAdsPlugin, {
  debug: process.env.NODE_ENV === 'development',
  enableMock: true
})

Vue.config.productionTip = false

Vue.use(Vuelidate)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  mounted() {
    this.$yandexAds.init();
  }
}).$mount('#app')
